import { combineReducers } from "redux";
import { geofencesState } from "./geofencesReducer";

export const geofencesReducer = combineReducers({
  geofencesState: geofencesState
});


